import { callContract } from '../contractClient'
import { contracts as duoContracts } from '../../../../shared/features/duo.contracts'

const providers = {
  duo: {
    label: 'Duo',
    emptyCredentials: () => ({ integrationKey: '', secretKey: '', apiHostname: '' }),
    complete: (credentials) => Boolean(
      credentials.integrationKey?.trim()
      && credentials.secretKey?.trim()
      && credentials.apiHostname?.trim(),
    ),
    async configure(credentials) {
      await callContract(duoContracts.updateIntegration, {
        body: {
          enabled: true,
          config: {
            credential_source: 'local',
            integration_key: credentials.integrationKey.trim(),
            secret_key: credentials.secretKey.trim(),
            api_hostname: credentials.apiHostname.trim(),
          },
        },
      })
    },
    Fields({ credentials, onChange, disabled }) {
      const update = (key) => (event) => onChange({ ...credentials, [key]: event.target.value })
      return (
        <>
          <p className="text-xs text-[var(--app-text-muted)]">Create a Duo Auth API application, then enter its credentials.</p>
          <label className="block text-sm">Integration key<input aria-label="Duo integration key" disabled={disabled} className="mt-1 w-full rounded-[var(--app-radius)] border border-[var(--app-border-strong)] bg-[var(--app-surface)] px-2.5 py-1.5" value={credentials.integrationKey} onChange={update('integrationKey')} /></label>
          <label className="block text-sm">Secret key<input aria-label="Duo secret key" disabled={disabled} type="password" className="mt-1 w-full rounded-[var(--app-radius)] border border-[var(--app-border-strong)] bg-[var(--app-surface)] px-2.5 py-1.5" value={credentials.secretKey} onChange={update('secretKey')} /></label>
          <label className="block text-sm">API hostname<input aria-label="Duo API hostname" disabled={disabled} placeholder="api-XXXXXXXX.duosecurity.com…" spellCheck={false} className="mt-1 w-full rounded-[var(--app-radius)] border border-[var(--app-border-strong)] bg-[var(--app-surface)] px-2.5 py-1.5" value={credentials.apiHostname} onChange={update('apiHostname')} /></label>
        </>
      )
    },
  },
}

export function getMfaSetupProviderUi(key) {
  return providers[key] || null
}

export function emptyMfaCredentials(key) {
  return getMfaSetupProviderUi(key)?.emptyCredentials() || {}
}

export async function configureMfaProviderIntegration(key, credentials) {
  const provider = getMfaSetupProviderUi(key)
  if (!provider) throw new Error(`Unsupported MFA provider: ${key}`)
  await provider.configure(credentials)
}

export function MfaProviderFields({ providerKey, credentials, onChange, disabled }) {
  const provider = getMfaSetupProviderUi(providerKey)
  if (!provider) return null
  const Fields = provider.Fields
  return <Fields credentials={credentials} onChange={onChange} disabled={disabled} />
}
